<template>
	<div :class="`social ${socialWhite}`">
		<div class="social__content" @mouseenter="showSocial = !showSocial" @mouseleave="showSocial = !showSocial">
			<transition name="slide-fade">
				<div v-if="showSocial" class="social__content">
					<a 
						@click="sendEvent('share_telegram', 'm_share_telegram')"
						href="https://t.me/share/url?url=https://k-travel2021.lenta.ru/&text=Мечтаешь увидеть Корею?"
						class="social__item social__item--telegram"
						onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
					></a>
					<a
						@click="sendEvent('share_odnoklassniki', 'm_share_odnoklassniki')"
						href="https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.title=Мечтаешь увидеть Корею?&st.shareUrl=https://k-travel2021.lenta.ru/"
						class="social__item social__item--ok"
						onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
					></a>
					<a 
						@click="sendEvent('share_twitter', 'm_share_twitter')" 
						href="https://twitter.com/intent/tweet?text=Мечтаешь увидеть Корею?&url=https://k-travel2021.lenta.ru/"
						class="social__item social__item--twitter"
						onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
					></a>
					<a 
						@click="sendEvent('share_vkontakte', 'm_share_vkontakte')" 
						href="https://vk.com/share.php?url=https://k-travel2021.lenta.ru/&title=Мечтаешь увидеть Корею?"
						class="social__item social__item--vk"
						onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
					></a>
					<a 
						@click="sendEvent('share_facebook', 'm_share_facebook')" 
						href="https://www.facebook.com/sharer/sharer.php?u=https://k-travel2021.lenta.ru/&t=Мечтаешь увидеть Корею?"
						class="social__item social__item--facebook"
						onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;"
					></a>
				</div>
			</transition>
			<a href="javascript:void(0)" class="social__item social__item--like"></a>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				showSocial: false,
			}
		},
		props: {
			socialWhite: String
		},
		methods: {
			sendEvent(event, eventMob) {
				if (window.innerWidth > 960) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'share'});
					this.$gtag.event('click', {event_category: 'link', 'event_label': event});
				} else {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_share'});
					this.$gtag.event('click', {event_category: 'link', 'event_label': eventMob});
				}
			},
		}
	}
</script>

<style lang="sass">
	.social
		position: fixed
		z-index: 100
		bottom: 0
		right: 0
		margin-bottom: vw(24px)
		margin-right: vw(11px)
		&--white
			.social__item--like
				background-image: url(../assets/img/like-light-line.svg)
				transition: all 300ms
				&:hover
					background-image: url(../assets/img/like-light.svg)
			.social__item--telegram
				background-image: url(../assets/img/telegram-light.svg)
			.social__item--ok
				background-image: url(../assets/img/ok-light.svg)
			.social__item--twitter
				background-image: url(../assets/img/twitter-light.svg)
			.social__item--vk
				background-image: url(../assets/img/vk-light.svg)
			.social__item--facebook
				background-image: url(../assets/img/facebook-light.svg)
		&__content
			display: flex
			flex-direction: column
			align-items: center
		&__item
			margin-top: vw(15px)
			&--telegram
				background-image: url(../assets/img/telegram.svg)
				background-size: contain
				background-repeat: no-repeat
				width: vw(20px)
				height: vw(17px)
				display: block
			&--ok
				background-image: url(../assets/img/ok.svg)
				background-size: contain
				background-repeat: no-repeat
				width: vw(14px)
				height: vw(23px)
				display: block
			&--twitter
				background-image: url(../assets/img/twitter.svg)
				background-size: contain
				background-repeat: no-repeat
				width: vw(17px)
				height: vw(16px)
				display: block
			&--vk
				background-image: url(../assets/img/vk.svg)
				background-size: contain
				background-repeat: no-repeat
				width: vw(20px)
				height: vw(12px)
				display: block
			&--facebook
				background-image: url(../assets/img/facebook.svg)
				background-size: contain
				background-repeat: no-repeat
				width: vw(8px)
				height: vw(18px)
				display: block
			&--like
				background-image: url(../assets/img/like-line.svg)
				background-size: contain
				background-repeat: no-repeat
				width: vw(20px)
				height: vw(19px)
				display: block
				margin-top: vw(18px)
				transition: all 300ms
				&:hover
					background-image: url(../assets/img/like.svg)
</style>


<style>
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>